<template>

    <v-event :date="event.created_at" :actions="[{ key: 'edit', value: 'Edit Event Settings' }, { key: 'delete', value: 'Delete Event' }]" @action="onActionSelected">
        <template #title>
            <v-swatch class="mr-10" :size="20" :color="event.event.color" />
            <span class="title">{{ event.event.name }}</span>
        </template>
        <template #body>
            <table>
                <tr>
                    <td class="key">date</td>
                    <td class="value">{{ event.created_at | dateTime }}</td>
                </tr>
                <tr v-for="property in properties" :key="property.id">
                    <td class="key">{{ property.name }}</td>
                    <td class="value"><v-value :value="property | valueForProperty(event.properties[property.name])" /></td>
                </tr>
            </table>
        </template>
    </v-event>

</template>

<script>

import CustomerApi from '@api/CustomerApi';
import Event from './Event';

export default {

    components: {
        'v-event': Event,
    },

    props: {
        event: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            show: true,
            isCollapsed: true,
        }
    },

    computed: {

        properties() {
            return this.event.event.properties.filter(p => {
                if (Object.keys(this.event.properties).includes(p.name)) {
                    return true;
                }
            });
        },

    },

    methods: {

        onActionSelected(item) {
            if (item.key === 'edit') {
                this.$router.push({
                    name: 'events-edit',
                    params: { id: this.event.event.id },
                });
            } else if (item.key === 'delete') {
                CustomerApi.deleteEvent(this.event.customer_id, this.event.id)
                    .then((response) => {
                        this.$store.commit('setAlertSuccess', this.$t('message.deleted'));
                        this.show = false;
                    }, (error) => {
                        this.$store.commit('setAlertWithError', error);
                    });
            }
        },

    },

}

</script>
